import styled from 'styled-components'

export const PageWrapper = styled.div`
  position: relative;
  padding: 0 50px;

  font-size: ${props => props.theme.fontSizes.campaigns.sections.section};
  .view-map {
    margin-left: 8px;
  }

  .link-back {
    display: block;
    float: left;
    margin: 6px 26px 0 0;
  }

  .section-wrapper {
    padding: 45px 40px 45px 40px;

    &.section-wrapper--padding,
    &:last-child {
      margin: 30px 0;

      table {
        tr {
          td:nth-child(3) {
            text-transform: lowercase;

            &:first-letter {
              text-transform: capitalize;
            }
          }

          td:nth-child(4) {
            position: relative;

            & > * {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              margin: auto;
              left: 0;
              right: 0;
              width: 23px;
            }
          }

          td:last-child {
            text-align: right;

            & > div > * {
              display: block;
              float: left;

              svg {
                margin: 0;
              }
            }

            & > div > *:last-child {
              margin-left: 20px;
              margin-right: 59px;
            }
          }

          th:first-child,
          td:first-child {
            padding-left: 40px;
          }

          td:last-child {
            padding-right: 0;
            text-align: right;
          }

          th:last-child {
            text-align: right;
            padding-right: 60px;
          }
        }
      }
    }

    .negative-margin {
      margin: 0 -40px 0 -40px;
    }

    .row {
      margin: 0;
      div[class^='col-'] {
        padding: 0;
      }

      &:first-child {
        margin: 0 0 30px 0;
      }
    }

    .section-title {
      margin: 0 0 33px 0;
    }

    .section-label {
      margin: 0 0 10px 0;
    }
  }
`
